export default __webpack_public_path__ + "static/media/IsologoManuable.6934d330.png";